/**
 *申请成为开发者表单规则
 *@author xujinjiang
 *@date 2022/3/30 10:07
 */
export const ApplyRules = {
  companyName: [
    {
      required: true,
      message: '请输入公司/机构名称',
      trigger: 'blur'
    }
  ],
  phone: [
    {
      required: true,
      message: '请输入手机号',
      trigger: 'blur'
    },
  ],
  name: [
    {
      required: true,
      message: '请输入联系人姓名',
      trigger: 'blur'
    }
  ],
  email: [
    {
      required: true,
      message: '请输入正确邮箱',
      trigger: 'blur'
    }
  ],
  province: [
    {
      required: true,
      message: '请选择省份',
      trigger: 'change'
    }
  ]
};

